/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FinancialPlanUpdateIncomeRequestDto
 */
export interface FinancialPlanUpdateIncomeRequestDto {
  /**
   *
   * @type {number}
   * @memberof FinancialPlanUpdateIncomeRequestDto
   */
  amount: number;
}

export function FinancialPlanUpdateIncomeRequestDtoFromJSON(json: any): FinancialPlanUpdateIncomeRequestDto {
  return FinancialPlanUpdateIncomeRequestDtoFromJSONTyped(json, false);
}

export function FinancialPlanUpdateIncomeRequestDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FinancialPlanUpdateIncomeRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    amount: json["amount"],
  };
}

export function FinancialPlanUpdateIncomeRequestDtoToJSON(value?: FinancialPlanUpdateIncomeRequestDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    amount: value.amount,
  };
}
